export const MuiSelect = {
  styleOverrides: {
    icon: {
      color: '#a8aeb8',
    },
  },
};
